import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PerformanceMonitor from "@/components/PerformanceMonitor";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Locations from "./pages/Locations";
import Toronto from "./pages/Toronto";
import Gallery from "./pages/Gallery";
import ElectricianServices from "./pages/ElectricianServices";
import PlumberServices from "./pages/PlumberServices";
import DrywallServices from "./pages/DrywallServices";
import GeneralContractingServices from "./pages/GeneralContractingServices";
import SkilledTradesServices from "./pages/SkilledTradesServices";
import CarpenterServices from "./pages/CarpenterServices";
import RoofingServices from "./pages/RoofingServices";
import FlooringServices from "./pages/FlooringServices";
import MasonryServices from "./pages/MasonryServices";
import HVACServices from "./pages/HVACServices";
import WeldingServices from "./pages/WeldingServices";
import HeavyEquipmentServices from "./pages/HeavyEquipmentServices";
import SpecialtyContractingServices from "./pages/SpecialtyContractingServices";
import DesignEngineeringServices from "./pages/DesignEngineeringServices";
import Ottawa from "./pages/Ottawa";
import Mississauga from "./pages/Mississauga";
import Hamilton from "./pages/Hamilton";
import London from "./pages/London";
import KitchenerWaterloo from "./pages/KitchenerWaterloo";
import AsphaltPavingServices from "./pages/AsphaltPavingServices";
import AsphaltPavingConcreteServices from "./pages/AsphaltPavingConcreteServices";
import BathroomRenovations from "./pages/BathroomRenovations";
import KitchenRenovations from "./pages/KitchenRenovations";
import Careers from "./pages/Careers";
import RestorationServices from "./pages/RestorationServices";
import DroneInspectionServices from "./pages/DroneInspectionServices";
import DeckFenceServices from "./pages/DeckFenceServices";
import PaintingServices from "./pages/PaintingServices";
import WindowsDoorsServices from "./pages/WindowsDoorsServices";
import Blog from "./pages/Blog";
import LandscapingServices from "./pages/LandscapingServices";
import FramingServices from "./pages/FramingServices";
import InsulationServices from "./pages/InsulationServices";
import ExcavationServices from "./pages/ExcavationServices";
import DemolitionServices from "./pages/DemolitionServices";
import TilingServices from "./pages/TilingServices";
import RenovationsServices from "./pages/RenovationsServices";
import StCatharines from "./pages/StCatharines";
import NiagaraFalls from "./pages/NiagaraFalls";
import Welland from "./pages/Welland";
import Burlington from "./pages/Burlington";
import Oakville from "./pages/Oakville";
import Brampton from "./pages/Brampton";
import Vaughan from "./pages/Vaughan";
import Markham from "./pages/Markham";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <PerformanceMonitor />
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/general-contracting" element={<GeneralContractingServices />} />
          <Route path="/services/skilled-trades" element={<SkilledTradesServices />} />
          <Route path="/services/carpenter" element={<CarpenterServices />} />
          <Route path="/services/roofing" element={<RoofingServices />} />
          <Route path="/services/flooring" element={<FlooringServices />} />
          <Route path="/services/masonry" element={<MasonryServices />} />
          <Route path="/services/hvac" element={<HVACServices />} />
          <Route path="/services/welding" element={<WeldingServices />} />
          <Route path="/services/heavy-equipment" element={<HeavyEquipmentServices />} />
          <Route path="/services/specialty-contracting" element={<SpecialtyContractingServices />} />
          <Route path="/services/design-engineering" element={<DesignEngineeringServices />} />
          <Route path="/services/asphalt-paving" element={<AsphaltPavingServices />} />
          <Route path="/services/asphalt-paving-concrete" element={<AsphaltPavingConcreteServices />} />
          <Route path="/services/bathroom-renovations" element={<BathroomRenovations />} />
          <Route path="/services/kitchen-renovations" element={<KitchenRenovations />} />
          <Route path="/services/electrician" element={<ElectricianServices />} />
          <Route path="/services/plumber" element={<PlumberServices />} />
          <Route path="/services/drywall" element={<DrywallServices />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/toronto" element={<Toronto />} />
          <Route path="/ottawa" element={<Ottawa />} />
          <Route path="/mississauga" element={<Mississauga />} />
          <Route path="/hamilton" element={<Hamilton />} />
          <Route path="/london" element={<London />} />
          <Route path="/kitchener-waterloo" element={<KitchenerWaterloo />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/services/restoration" element={<RestorationServices />} />
          <Route path="/services/drone-inspections" element={<DroneInspectionServices />} />
          <Route path="/services/deck-fence" element={<DeckFenceServices />} />
          <Route path="/services/painting" element={<PaintingServices />} />
          <Route path="/services/windows-doors" element={<WindowsDoorsServices />} />
          <Route path="/services/landscaping" element={<LandscapingServices />} />
          <Route path="/services/framing" element={<FramingServices />} />
          <Route path="/services/insulation" element={<InsulationServices />} />
          <Route path="/services/excavation" element={<ExcavationServices />} />
          <Route path="/services/demolition" element={<DemolitionServices />} />
          <Route path="/services/tiling" element={<TilingServices />} />
          <Route path="/services/renovations" element={<RenovationsServices />} />
          <Route path="/st-catharines" element={<StCatharines />} />
          <Route path="/niagara-falls" element={<NiagaraFalls />} />
          <Route path="/welland" element={<Welland />} />
          <Route path="/burlington" element={<Burlington />} />
          <Route path="/oakville" element={<Oakville />} />
          <Route path="/brampton" element={<Brampton />} />
          <Route path="/vaughan" element={<Vaughan />} />
          <Route path="/markham" element={<Markham />} />
          <Route path="/blog" element={<Blog />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
